export const STACKBLITZ_EDIT_MODE_HEIGHT = 400
export const STACKBLITZ_PREVIEW_MODE_HEIGHT = 360